/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global API_PATH, globalData, lng, snackbar, CONTENT_TARGET, CONTENT, schema, restCollection, RestEdit */

function Schema() {
  if (!this instanceof Schema) return new Schema();

  //Note: init function is under the attribute assigments

  const COLLECTION_ADD_MODE = {
    /**
     * Existing Items could be added to collection
     */
    ADD: 0,
    /**
     * Items could be only added by creating a new one
     */
    CREATE: 1,
    /**
     * Combination of <i>ADD</i> and <i>CREATE</i>
     */
    ADD_CREATE: 2,
    /**
     * Create trough an other schema.
     * Schema is the attribute name of the collection or the via attribute.
     */
    THROUGH_ADD: 3,
    /**
     * Items can be created and imported through a csv import
     */
    CREATE_IMPORT: 4,
  };
  //make the const public, but not enumerable
  Object.defineProperty(this, "COLLECTION_ADD_MODE", {
    enumerable: false,
    value: COLLECTION_ADD_MODE,
  });

  const ICONS = {
    ARROW_BACK: '<i class="material-icons">arrow_back</i>',
    DONE: '<i class="material-icons">done</i>',
    EDIT: '<i class="material-icons">edit</i>',
    REMOVE: '<i class="material-icons">close</i>',
    INFO: '<i class="material-icons">info_outline</i>',
  };
  Object.defineProperty(this, "ICONS", {
    enumerable: false,
    value: ICONS,
  });

  /*
   * -- Schema Explenation --
   *
   * - endPoint<String>: API_PATH${restEndpoint}
   *
   * - schemaData<Object>
   *   Object with attribute names as keys
   *   Label strings will be got from the Lng module. The pattern is `${schema}_${attributeName}`.
   *
   *   - type<String>: text | password | number | date | checkbox | model | collection | file | static [EXPERIMENTAL] //TODO datetime
   *     will be used for input.type
   *     exceptions are model and collection. See below.
   *
   *   - required<Boolean>
   *     On creation mode will be applied to the input
   *
   *   - minLength<Integer>, maxLength<Integer>
   *     Will be used for creating an input validation pattern
   *
   *   - min<Number>, max<Number>, step<Number>
   *     Will set the html input attributes.
   *
   *   - access<Function>: row => { .. }
   *     Function wich will be executed on edit/create mode. Row is the specific instance and the only parameter
   *     Return true to give user edit access. False else.
   *
   *   - hideInTable<Boolean>
   *     Set this to false if the attribute should not be displayed in RestTable
   *
   *   - class<string> [EXPERIMENTAL]
   *      Sets this class(es) to the element
   *
   *   - wrapperClass<string> [EXPERIMENTAL]
   *      Sets this class(es) to the parent element (object => div / string => p)
   *
   *   - defaultsTo<String>,<Boolean>
   *     Default value for creation of blank instances. Do not use on type='model' or type='collection'
   *
   *   - getString<Function>: row => { .. }
   *     Colud be used to generate a custom string for displaying in RestTable.
   *     Is required on type='model' and type='collection'
   *
   *   - customEdit<Function>: row => { .. }
   *     Use this if you want to customize the edit flow of this attribute.
   *     This function will be called when user set the focus on the input.
   *
   *     Have to return an object with <i>onclose</i> and <i>oncancel</i> as callbacks for end of edit.
   *     Call <i>onclose</i> with the new value as a single parameter. It will be saved immediately.
   *     This callback returns a Promise resolving to the new instance. Possibly with a different id.
   *     Call <i>oncancel</i> to remove lock on input field.
   *
   *     Take care you should handle showing the edit frame and loading data
   *     inside this function.
   *
   *   //-- type='model' and type='collection' exclusive attributes --
   *
   *   - via<String>
   *     If the attribute name is not equal with the pointing to schema name, you have to specify the schema name here.
   *     This is not optional.
   *     Example: group.manager is from schema user. -> via='user'
   *
   *   //-- type='model' exclusive attributes --
   *
   *   - blueprint<Boolean>
   *     Set this to true, if the model should act as a blueprint.
   *     After selecting all schema equal data will be applied from the model to the instance.
   *
   *   //-- type='collection' exclusive attributes --
   *
   *   - cols<Array<Object>>
   *     Array with columns for showing the collection.
   *     To not show the collection in the edit view, do not specify this attribute.
   *
   *     - key<String>
   *       For simple showing the value of collection item from attribute (key) use this.
   *
   *     - edit<Boolean>
   *       Set this to true if the value of populated collection item should be editable directly from the table of the parent item.
   *       Collections and models could not be edited here.
   *       Best practise is to use this to hide through tables.
   *
   *     - label<String>
   *       For overwriting the automatic generated label or if you do not specified the key attribute.
   *
   *     - function<Function>: (subject<RestSubject>, row<object>) => { .. }
   *       For custom generating the value by a function. Return a string.
   *       row is the collection item. subject parent object with all data and other collections.
   *       Return 'remove-icon' to generate a button the user could remove this item from collection.
   *       Take care of additional data when you are using populate=true.
   *       Alternativly this function could return an <Element> with event listeners and so on.
   *
   *   - addMode<COLLECTION_ADD_MODE>
   *     ADD: Only existing items are possible to add to this collection
   *     CREATE: Items could only be added to this collection by creating a new one
   *     ADD_CREATE: Adding existing and creating a new one are allowed
   *
   *   - populate<Boolean>
   *     Optional. Set this to true, if you want to populate items in this collection. Be carefull of performance!
   *
   * - accessCreate<Function>
   *   Deside if user should be able to create new instances.
   *   Return true for allowing access. False else.
   *   This function is optional. If not specified, access is granted.
   *
   * - beforeCreate<Function>: function (object) { .. }
   *   Additional function to validate a new object before send data to server.
   *   Make shure you add some user notification here. Example: snackbar.show({message: lng.get('user_error_partnerGroup-required')})
   *   Return false on invalid object. True else.
   *
   *  // -- Additional Information about type Static.
   *      The static entity represents an experimental solution to provide simple 1 to 1 relation.
   *      Collection are not able to to this.
   **/

  this.statistic = {
    endPoint: API_PATH + "statistic",
  };
  this.user = {
    endPoint: API_PATH + "user",
    schemaData: {
      login: {
        type: "text",
        required: true,
        access: (row) => accessUserEdit(row),
      },
      password: {
        hideInTable: true,
        type: "password",
        minLength: 6,
        required: true,
        access: (row) => accessUserEdit(row),
      },
      active: {
        hideInTable: true,
        type: "checkbox",
        defaultsTo: true,
        access: (row) => accessUserEdit(row) && !row.active,
      },
      admin: {
        type: "checkbox",
        defaultsTo: false,
        access: (row) => globalData.user.admin,
      },
      manage_partner: {
        type: "checkbox",
        defaultsTo: false,
        access: (row) => globalData.user.admin,
      },
      dashboard_user: {
        type: "checkbox",
        defaultsTo: false,
        access: (row) => globalData.user.admin,
      },
      partnerGroupManager: {
        type: "collection",
        via: "partnerGroup",
        getString: (row) => {
          const names = row.partnerGroupManager.map((pg) => pg.name);
          return names.join(", ");
        },
        //until no cols are defined, this won't be shown in the edit view
      },
      profitCenter: {
        type: "text",
        access: (row) => accessUserEdit(row),
      },
    },
    accessCreate: function () {
      const user = globalData.user;
      return (
        user &&
        (user.admin ||
          user.manage_partner ||
          user.partnerGroupManager.length > 0)
      );
    },
    beforeCreate: function (object) {
      if (globalData.user.admin || globalData.user.manage_partner) return true;

      if (globalData.user.partnerGroupManager.length > 0) {
        return true;
      }
      snackbar.show({
        message: lng.get("user_error_partnerGroup-required"),
      });
      return false;
    },
  };

  function accessUserEdit(row) {
    if (
      !row.id || //new user
      globalData.user.admin || //admin
      globalData.user.manage_partner || //support
      globalData.user.id === row.id
    )
      //self edit
      return true;
    // manager of partnergroup the user is in are able to edit
    const loggedInUserIsNoManagerOf = globalData.user.partnerGroup.filter(
      (pg) => pg.manager === globalData.user.id
    );
    return loggedInUserIsNoManagerOf.length > 0;
  }

  this.partnerGroup = {
    endPoint: API_PATH + "partnerGroup",
    schemaData: {
      name: {
        type: "text",
        required: true,
        unique: true,
      },
      active: {
        hideInTable: true,
        type: "checkbox",
        defaultsTo: true,
        access: function () {
          const user = globalData.user;
          return (
            user &&
            (user.admin ||
              user.manage_partner ||
              user.partnerGroupManager.length > 0)
          );
        },
      },
      invisible: {
        // Direktkunde!!!
        type: "checkbox",
        defaultsTo: false,
      },
      partner: {
        type: "collection",
        getString: (row) => {
          const partner = row.partner.map((p) => p.name);
          return partner.join(", ");
        },
        cols: [
          { key: "name" },
          { key: "adress" },
          { key: "mail" },
          { key: "phone" },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.PARTNER, { id: row.id });
              });
              return icon;
            },
          },
        ],
      },
      manager: {
        type: "model",
        via: "user",
        required: true,
        getString: (row) => (row.manager ? row.manager.login : ""),
        access: (row) => !row.id,
      },
      user: {
        hideInTable: true,
        type: "collection",
        getString: (row) => {
          const user = row.user.map((u) => u.login);
          return user.join(", ");
        },
        addMode: COLLECTION_ADD_MODE.ADD,
        cols: [
          { key: "login" },
          {
            label: "Zugriff aufheben",
            function: (subject, row) => {
              return subject.data.manager && subject.data.manager.id === row.id
                ? "Nicht möglich, da Manager"
                : "remove-icon";
            },
          },
        ],
      },
      /* currentContract: {
                 type: 'model',
                 access: row => false, //read only
                 getString: row => {
                     var cc = row.currentContract;
                     if (!cc)
                         return 'Kein aktiver Vertrag vorhanden';
                     return `${cc.cost}€ | Lizenzen:${cc.licence_contingent}, Partner:${cc.partner_contingent}`;
                 }
             },*/
      contract: {
        type: "collection",
        hideInTable: true,
        //addMode: COLLECTION_ADD_MODE.ADD,
        cols: [
          { key: "licence_contingent" },
          { key: "partner_contingent" },
          {
            key: "cost",
            function: (subject, row) => row.cost + " €",
          },
          { key: "duration" },
          { key: "period_of_notice" },
          {
            key: "start_date",
            function: (subject, row) => {
              if (!row.start_date) return "";
              return new Date(row.start_date).toLocaleDateString();
            },
          },
          {
            key: "end_date",
            function: (subject, row) => {
              if (!row.end_date) return "";
              return new Date(row.end_date).toLocaleDateString();
            },
          },
          { key: "auto_extend" },
          { key: "canceled" },
        ],
      },
      appLicence: {
        type: "collection",
        populate: true,
        hideInTable: true,
        //addMode: COLLECTION_ADD_MODE.THROUGH_ADD,
        getString: (row) => row.appLicence.length,
        cols: [
          { key: "key" },
          {
            key: "device_name",
            edit: true,
          },
          { key: "last_activity" },
          {
            key: "isFree",
            edit: true,
          },
        ],
      },
    },
    accessCreate: function () {
      return (
        globalData.user &&
        (globalData.user.admin || globalData.user.manage_partner)
      );
    },
  };

  this.partner = {
    endPoint: API_PATH + "partner",
    schemaData: {
      name: {
        type: "text",
        required: true,
      },
      adress: {
        type: "text",
        hideInTable: true,
      },
      phone: {
        type: "text",
      },
      mail: {
        type: "email",
        hideInTable: true,
      },
      barcodeExpression: {
        type: "text",
        hideInTable: true,
        tooltip:
          "Folgende Variablen können hier verwendet werden:<br>Aufnahmedatum (DD.MM.YY): $date$<br>Aufnahmedatum (DDMMYY): $nddate$<br>Aufnahmedatum (DD.MM.YYYY): $datey$<br>Aufnahmedatum (DDMMYYYY): $nddatey$<br>Aufnahme-ID (ohne feste Länge): $id$<br>Aufnahme-ID (mit Länge N): $id:N$",
      },
      exportNameing: {
        type: "text",
        hideInTable: true,
        tooltip:
          "Folgende Variablen für die einzelnen PDFs verwendet werden:<br>Aufnahmedatum (DD.MM.YY): $date$<br>Aufnahmedatum (DD.MM.YYYY): $datelong$<br>Name des Partners: $name$<br>Formularbezeichnung: $form$<br>Vorname des Abonnenten: $firstname$<br>Nachname des Abonnenten: $lastname$<br>Stadt des Abonnenten: $city$",
      },
      partnerLogo: {
        type: "file",
        via: "partnerLogo",
        hideInTable: true,
        showThumbnail: true,
      },
      streetSchema: {
        type: "file",
        via: "streetSchema",
        hideInTable: true,
        showThumbnail: false,
        tooltip:
          "Für den Upload müssen die folgenden Punkte beachtet werden:" +
          "<br>1. Als Straßenverzeichnis kann eine .zip-Datei oder eine .csv-Datei verwendet werden." +
          "<br>2. In der .zip-Datei darf beim Upload nur eine .csv-Datei enthalten sein." +
          "<br>3. Die .csv-Datei muss mithilfe von Excel oder einem anderen Programm im UTF-8 Format gespeichert werden." +
          "<br>4. Die folgende Reihenfolge der Spalten muss beachtet werden: PLZ -> Ort -> Straße",
      },
      deliveryArea: {
        type: "area",
        hideInTable: true,
      },
      zipEdition: {
        type: "file",
        via: "zipEdition",
        hideInTable: true,
        showThumbnail: false,
        tooltip:
          "Für den Upload der PLZ-Liste müssen folgende Punkte beachtet werden: <br>" +
          "1. Die folgende Reihenfolge der Spalten muss beachtet werden: PLZ -> Ort -> Name der Zeitung -> PVA <br>" +
          "2. Bei mehreren Zeitungen für eine PLZ können diese einfach <br> in einer neuen Zeile mit der selben PLZ + Ort hinzugefügt werden <br>" +
          "3. Sollte es mehrere Zeitungen für eine PLZ geben, <br> versucht die Anwendung ein Auswahlelement mit dem Namen der Zeitung in der CSV zu finden",
      },
      weeklyExportMails: {
        type: "text",
        hideInTable: true,
        tooltip:
          "E-Mail-Adressen für den Export der Promoter-Ergebnisse (Kommata getrennt)",
      },
      readingSamplesPlanned: {
        type: "number",
        hideInTable: true,
        tooltip: "Geplante Anzahl der wöchentlichen Leseproben",
      },
      active: {
        type: "checkbox",
        defaultsTo: true,
        access: (row) => true,
      },
      user: {
        hideInTable: true,
        type: "collection",
        getString: (row) => {
          const user = row.user.map((u) => u.login);
          return user.join(", ");
        },
        addMode: COLLECTION_ADD_MODE.ADD,
        cols: [
          { key: "login" },
          {
            label: "Zugriff aufheben",
            function: (subject, row) => {
              return "remove-icon";
            },
          },
        ],
      },
      //-1 no autodelete
      autodelete_default: {
        type: "number",
        defaultsTo: -1,
        min: -1,
        hideInTable: true,
      },
      notificationMail: {
        type: "static",
        hideInTable: true,
        via: "notificationMail",
        populate: true,
      },
      locationPartner: {
        type: "collection",
        getString: (row) => row.locationPartner.length,
        populate: true,
        addMode: COLLECTION_ADD_MODE.CREATE_IMPORT,
        cols: [
          {
            key: "active",
            edit: true,
          },
          {
            label: lng.get("location"),
            sorting: true,
            sortingKey: "location.name",
            align: "left",
            function: (subject, row) => row.location.name,
          },
          {
            key: "adress",
            sorting: true,
            sortingKey: "location.adress",
            align: "left",
            function: (subject, row) => row.location.adress,
          },
          {
            key: "mas_number",
            edit: true,
            sorting: true,
            align: "left",
            sortingKey: "mas_number",
          },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.LOCATION, {
                  id: row.location.id,
                });
              });
              return icon;
            },
          },
        ],
      },
      employeePartner: {
        type: "collection",
        getString: (row) =>
          row.employeePartner.filter((ep) => ep.active).length,
        populate: true,
        addMode: COLLECTION_ADD_MODE.THROUGH_ADD,
        cols: [
          {
            key: "active",
            edit: true,
          },
          {
            label: lng.get("employee"),
            function: (subject, row) => row.employee.name,
          },
          {
            key: "number",
            edit: true,
          },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.EMPLOYEE, {
                  id: row.employee.id,
                });
              });
              return icon;
            },
          },
        ],
      },
      formPartner: {
        type: "collection",
        getString: (row) => row.formPartner.length,
        populate: true,
        cols: [
          {
            key: "form",
            function: (subject, row) =>
              schema.form.schemaData.name.getString(row.form),
          },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.FORM, { id: row.form.id });
              });
              return icon;
            },
          },
        ],
      },
      partnerGroup: {
        type: "model",
        required: true,
        getString: (row) => row.partnerGroup.name,
      },
      salesManager: {
        type: "model",
        required: true,
        hideInTable: true,
        via: "user",
        getString: (row) => {
          return row.salesManager ? row.salesManager.login : "";
        },
      },
      affiliates: {
        type: "collection",
        getString: (row) => row.affiliates.length,
        populate: true,
        addMode: COLLECTION_ADD_MODE.THROUGH_ADD,
        cols: [
          {
            label: "Formular Name",
            function: (subject, row) => row.form.name + " v" + row.form.version,
          },
          {
            label: "Angebot entfernen",
            function: (subject, row) => {
              return "remove-icon";
            },
          },
        ],
      },
    },
    accessCreate: function () {
      const user = globalData.user;
      return (
        user &&
        (user.admin ||
          user.manage_partner ||
          user.partnerGroupManager.length > 0)
      );
    },
  };

  this.partnerLogo = {
    endPoint: API_PATH + "partnerLogo",
    schemaData: {
      partner: {
        type: "model",
        required: true,
      },
    },
  };

  this.streetSchema = {
    endPoint: API_PATH + "streetSchema",
    schemaData: {
      name: {
        type: "text",
        required: false,
      },
      partner: {
        type: "model",
        required: true,
      },
    },
  };

  this.zipEdition = {
    endPoint: API_PATH + "zipEdition",
    schemaData: {
      name: {
        type: "text",
        required: false,
      },
      partner: {
        type: "model",
        required: true,
      },
    },
  };

  this.mailAttachment = {
    endPoint: API_PATH + "mailAttachment",
    schemaData: {
      backendName: {
        type: "text",
        required: false,
      },
      filename: {
        type: "text",
      },
      path: {
        type: "text",
      },
      mailContent: {
        type: "model",
        required: true,
      },
    },
  };

  this.mailContent = {
    endPoint: API_PATH + "mailContent",
    schemaData: {
      subject: {
        type: "text",
        access: true,
        required: true,
      },
      htmlBody: {
        type: "area",
        access: true,
        required: true,
      },
      mailFields: {
        type: "area",
        access: false,
      },
      mailAttachment: {
        type: "file",
        via: "mailAttachment",
        hideInTable: true,
      },
      form: {
        type: "static",
      },
    },
  };
  this.notificationMail = {
    endPoint: API_PATH + "notificationMail",
    schemaData: {
      fromadress: {
        type: "text",
        required: true,
      },
      hostname: {
        type: "text",
        required: true,
      },
      port: {
        type: "text",
        required: true,
      },
      username: {
        type: "text",
        required: true,
      },
      password: {
        type: "password",
        required: true,
      },
      active: {
        type: "checkbox",
        required: true,
      },
      smtp_authenfitication: {
        type: "checkbox",
        required: true,
      },
      partner: {
        type: "static",
      },
    },
  };

  this.contract = {
    endPoint: API_PATH + "contract",
    schemaData: {
      partnerGroup: {
        type: "model",
        required: true,
        getString: (row) => row.partnerGroup.name,
        access: (row) => !row.id, //only on creation
      },
      contractBlueprint: {
        type: "model",
        required: true,
        blueprint: true,
        getString: (row) => row.contractBlueprint.name,
        access: (row) => !row.id, //only on creation
      },
      cost: {
        type: "number",
        step: 0.01,
        required: true,
        getString: (row) => row.cost + " &euro;",
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      //how many employee could be assigned to all partner of the partner group
      //-1: unlimited
      licence_contingent: {
        type: "number",
        required: true,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      //how many partner could be inside a partner group
      //-1: unlimited
      partner_contingent: {
        type: "number",
        required: true,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      start_date: {
        type: "date",
        required: true,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      end_date: {
        type: "date",
        defaultsTo: null,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      //duration of the contract on first sign
      duration: {
        type: "number", //months
        required: true,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      //without cancelation, a contract will be automaticly extended by this period
      auto_extend: {
        type: "number", //months
        required: true,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      //time for cancelation before end of period
      period_of_notice: {
        type: "number", //months
        required: true,
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
      canceled: {
        type: "checkbox",
        defaultsTo: false,
        getString: (row) =>
          row.canceled ? '<i class="material-icons">warning</i>' : "",
        access: () => globalData.user.admin || globalData.user.manage_partner,
      },
    },
    accessCreate: function () {
      return (
        globalData.user &&
        (globalData.user.admin || globalData.user.manage_partner)
      );
    },
  };

  this.contractBlueprint = {
    endPoint: API_PATH + "contractBlueprint",
    schemaData: {
      name: {
        type: "text",
        required: true,
      },
      //cost per month
      cost: {
        type: "number",
        step: 0.01,
        defaultsTo: 0,
        required: true,
      } /*
            contract: {
                type: 'collection',
                populate: true,
                getString: row => row.contract.length,
                cols: [
                    {
                        label: lng.get('contract_partnerGroup'),
                        function: (subject, contract) => contract.partnerGroup.name
                    },
                    {
                        label: lng.get('contract_cost'),
                        function: (subject, contract) => contract.cost + ' &euro;'
                    },
                    {
                        label: lng.get('contract_employeeContingent'),
                        function: (subject, contract) => contract.licence_contingent
                    },
                    {
                        label: lng.get('contract_partnerContingent'),
                        function: (subject, contract) => contract.partner_contingent
                    },
                    {
                        label: lng.get('contract_startDate'),
                        function: (subject, contract) => new Date(contract.start_date).toISOString().split('T')[0]
                    },
                    {
                        label: lng.get('contract_endDate'),
                        function: (subject, contract) => {
                            var endDate = contract.start_date;
                            if (!endDate)
                                return '';
                            return new Date(contract.start_date).toISOString().split('T')[0];
                        }
                    },
                    {
                        label: lng.get('contract_duration'),
                        function: (subject, contract) => contract.duration
                    },
                    {
                        label: lng.get('contract_autoExtend'),
                        function: (subject, contract) => contract.auto_extend
                    },
                    {
                        label: lng.get('contract_periodOfNotice'),
                        function: (subject, contract) => contract.period_of_notice
                    },
                    {
                        label: lng.get('contract_canceled'),
                        function: (subject, contract) => that.contract.schemaData.canceled.getString(contract)
                    }
                ]
            },*/,
      active: {
        type: "checkbox",
        defaultsTo: true,
      },
      //how many employee could be assigned to all partner of the partner group
      //-1: unlimited
      licence_contingent: {
        type: "number",
        defaultsTo: -1,
        required: true,
      },
      //how many partner could be inside a partner group
      //-1: unlimited
      partner_contingent: {
        type: "number",
        defaultsTo: -1,
        required: true,
      },
      //duration of the contract on first sign
      duration: {
        type: "number", //months
        required: true,
      },
      //time for cancelation before end of period
      //should not be bigger then auto_extend
      period_of_notice: {
        type: "number", //months
        required: true,
      },
      //without cancelation, a contract will be automaticly extended by this period
      //0: no auto extend
      auto_extend: {
        type: "number", //months
        required: true,
      },
    },
  };

  this.employee = {
    endPoint: API_PATH + "employee",
    schemaData: {
      name: {
        type: "text",
        required: true,
      },
      login: {
        type: "text",
        required: true,
        unique: true,
      },
      password: {
        type: "text",
        required: true,
        hideInTable: true,
      },
      phone: {
        type: "text",
      },
      mail: {
        type: "email",
      },
      active: {
        type: "checkbox",
        defaultsTo: true,
        access: (row) => true,
      },
      lastLogin: {
        type: "date",
        access: (row) => false,
        getString: (row) => {
          if (row.employeeToken) {
            if (
              row.employeeToken.length > 0 &&
              row.employeeToken[row.employeeToken.length - 1]
            ) {
              return new Date(
                row.employeeToken[row.employeeToken.length - 1].last_usage
              ).toLocaleDateString("de-DE");
            }
          }
        },
        getData: (data) => {
          if (data.employeeToken) {
            if (
              data.employeeToken.length > 0 &&
              data.employeeToken[data.employeeToken.length - 1]
            ) {
              return new Date(
                data.employeeToken[data.employeeToken.length - 1].last_usage
              );
            }
          }
        },
      },
      partner: {
        type: "model",
        hideInTable: true,
        access: (row) => !row.id, // writeOnly for creation
        getString: (row) => {
          return row.partner.name;
        },
      },
    },
    beforeCreate: function (object) {
      if (object.partner) return true;

      snackbar.show({
        message: lng.get("employee_error_partner-required"),
      });
      return false;
    },
  };

  this.employeePartner = {
    endPoint: API_PATH + "employeePartner",
    schemaData: {
      number: {
        type: "text",
      },
      active: {
        type: "checkbox",
        defaultsTo: true,
      },
      //employee and partner are a combined unique index. specified in bootstrap.js
      partner: {
        type: "model",
        required: true,
        getString: (row) => row.partner.name,
      },
      employee: {
        type: "model",
        required: true,
        getString: (row) => row.employee.name,
      },
      customer: {
        type: "collection",
      },
    },
  };

  this.locationPartner = {
    endPoint: API_PATH + "locationPartner",
    schemaData: {
      partner: {
        type: "model",
        required: true,
        getString: (row) => row.partner.name,
      },
      locationname: {
        type: "text",
        required: true,
      },
      adress: {
        type: "text",
        required: true,
      },
      active: {
        type: "checkbox",
        defaultsTo: true,
      },
      mas_number: {
        type: "text",
      },
      customer: {
        type: "collection",
      },
    },
  };

  this.location = {
    endPoint: API_PATH + "location",
    schemaData: {
      name: {
        type: "text",
        required: true,
      },
      adress: {
        type: "text",
        required: true,
      },
      active: {
        type: "checkbox",
        defaultsTo: true,
        access: (row) => !row.active,
      },
      //source: https://gist.github.com/PascalAnimateur/b73617f0a27475fd4ccb
      // This is the attribute used for the place's geolocation.
      // Be careful to store it as [ lng, lat ] or else geoNear queries will give imprecise results.
      /*latitude: {
                type: 'number',
                step: 0.01,
                required: false,
                defaultsTo: '0.0',
                hideInTable: true,
            },
            longitude: {
                type: 'number',
                step: 0.01,
                required: false,
                defaultsTo: '0.0',
                hideInTable: true,
            },*/
      partner: {
        type: "model",
        hideInTable: true,
        access: (row) => !row.id, // writeOnly for creation
        getString: (row) => row.partner.name,
      },
    },
    beforeCreate: function (object) {
      if (object.partner) return true;

      snackbar.show({
        message: lng.get("location_error_partner-required"),
      });
      return false;
    },
  };

  this.form = {
    endPoint: API_PATH + "form",
    schemaData: {
      name: {
        type: "text",
        required: true,
        getString: (row) => row.name + " v" + row.version,
      },
      template: {
        type: "checkbox",
        defaultsTo: false,
        access: (row) =>
          (globalData.user.admin || globalData.user.manage_partner) &&
          !row.productive,
      },
      schema: {
        type: "json",
        required: true,
        hideInTable: true,
        customEdit: (row) => {
          const formBuilder = new FormBuilder();
          formBuilder.loadJson(row.data.schema);

          document
            .getElementById(CONTENT_TARGET.currentContent.css_id)
            .appendChild(formBuilder.node);

          return formBuilder;
        },
        access: (row) => row.id,
      },
      active: {
        type: "checkbox",
        defaultsTo: true,
        access: (row) => !row.template,
      },
      category: {
        type: "text",
        hideInTable: true,
        tooltip:
          "Kategorie für die Leseprobenwochenübersicht. <br>" +
          '"Leseproben / Leseproben" wird in zwei Spalten getrennt (Print + E-Paper). <br>' +
          '"Gewinnspiel" wird nach OptIn gefiltert. <br>' +
          "Alle anderen Werte werden als normale Kategorie behandelt.",
      },
      activeFrom: {
        type: "text",
        getString: (row) => row.activeFrom,
        tooltip: "Bitte im Format 01.01.2019 eintragen",
      },
      activeTo: {
        type: "text",
        getString: (row) => row.activeTo,
        tooltip: "Bitte im Format 01.01.2019 eintragen",
      },
      productive: {
        type: "checkbox",
        defaultsTo: false,
        access: (row) => !row.template && !row.productive,
      },
      isAffiliate: {
        type: "checkbox",
        defaultsTo: false,
        access: (row) => !row.template,
      },
      partner: {
        type: "model",
        via: "partner",
        getString: (row) => {
          if (row.formPartner) {
            if (row.formPartner.length > 0)
              return row.formPartner[0].partner.name;
            return "";
          } else return row.partner.name;
        },
      },
      mailContent: {
        type: "static",
        hideInTable: true,
        via: "mailContent",
        populate: true,
      },
      formExportCsv: {
        type: "collection",
        hideInTable: true,
        addMode: COLLECTION_ADD_MODE.CREATE,
        cols: [
          { key: "name" },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.FORM_EXPORT_CSV, {
                  id: row.id,
                  form: subject.data,
                });
              });
              return icon;
            },
          },
        ],
      },
      formExportXml: {
        type: "collection",
        hideInTable: true,
        addMode: COLLECTION_ADD_MODE.CREATE,
        cols: [
          { key: "name" },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.FORM_EXPORT_XML, {
                  id: row.id,
                  form: subject.data,
                });
              });
              return icon;
            },
          },
        ],
      },
      formExportPdf: {
        type: "collection",
        hideInTable: true,
        addMode: COLLECTION_ADD_MODE.CREATE,
        cols: [
          { key: "name" },
          {
            function: function (subject, row) {
              let icon = document.createElement("i");
              icon.insertAdjacentHTML("beforeend", schema.ICONS.EDIT);
              icon = icon.children[0];
              icon.classList.add("click");
              icon.addEventListener("click", function (e) {
                CONTENT_TARGET.changeContent(CONTENT.FORM_EXPORT_PDF, {
                  id: row.id,
                  form: subject.data,
                });
              });
              return icon;
            },
          },
        ],
      },
    },
    beforeCreate: function (object) {
      //            if (globalData.user.admin || globalData.user.manage_partner)
      //                return true;

      if (object.partner || object.template) return true;

      snackbar.show({
        message: lng.get("form_error_partner-required"),
      });
      return false;
    },
  };
  this.formExportPdf = {
    endPoint: API_PATH + "formExportPdf",
    schemaData: {
      name: {
        type: "text",
        hideInTable: true,
        required: true,
      },
      config: {
        type: "json",
        required: true,
        hideInTable: true,
        customEdit: (row) => {
          let view = CONTENT.FORM_EXPORT_PDF;
          if (CONTENT_TARGET.currentContent !== view) return;

          let form = view.data.parentForm;
          let basicWrapper = document.querySelector(`#${view.css_id}`); // .basic`);

          /**
           * @type FormExportPdfBuilder
           */
          let builder = new FormExportPdfBuilder();
          view.data.configBuilder = builder;

          builder.loadFormSchema(form.schema);

          if (row && row.data && row.data.config) builder.load(row.data.config);
          basicWrapper.appendChild(builder.node);
          return builder;
        },
        access: (row) => !!row.id,
      },
      form: {
        type: "model",
        hideInTable: true,
        getString: (row) => schema.form.schemaData.name.getString(row.form),
      },
      formPartner: {
        type: "collection",
        populate: true,
        hideInTable: true,
        getString: (row) =>
          row.formPartner.map((fp) => fp.partner.name).join(", "),
      },
    },
  };
  this.formExportCsv = {
    endPoint: API_PATH + "formExportCsv",
    schemaData: {
      name: {
        type: "text",
        hideInTable: true,
        required: true,
      },
      config: {
        type: "json",
        required: true,
        hideInTable: true,
        customEdit: (row) => {
          const view = CONTENT.FORM_EXPORT_CSV;
          if (CONTENT_TARGET.currentContent !== view) return;

          const form = view.data.parentForm;
          const basicWrapper = document.querySelector(`#${view.css_id}`); // .basic`);

          /**
           * @type FormExportCsvBuilder
           */
          const builder = new FormExportCsvBuilder();
          view.data.configBuilder = builder;

          builder.loadFormSchema(form.schema);

          if (row && row.data && row.data.config) builder.load(row.data.config);
          basicWrapper.appendChild(builder.node);
          return builder;
        },
        access: (row) => !!row.id,
      },
      csvEncoding: {
        type: "select",
        hideInTable: true,
        access: (row) => {
          const config = JSON.parse(row.config);
          return config.length > 0;
        },
        options: [
          {
            value: "utf-8-bom",
            text: "UTF-8 BOM",
          },
          {
            value: "ansi",
            text: "ANSI",
          },
        ],
      },
      form: {
        type: "model",
        hideInTable: true,
        getString: (row) => schema.form.schemaData.name.getString(row.form),
      },
      formPartner: {
        type: "collection",
        populate: true,
        hideInTable: true,
        getString: (row) =>
          row.formPartner.map((fp) => fp.partner.name).join(", "),
      },
    },
  };

  this.formExportXml = {
    endPoint: API_PATH + "formExportXml",
    schemaData: {
      name: {
        type: "text",
        hideInTable: true,
        required: true,
      },
      config: {
        type: "json",
        required: true,
        hideInTable: true,
        customEdit: (row) => {
          let view = CONTENT.FORM_EXPORT_XML;
          if (CONTENT_TARGET.currentContent !== view) return;

          let form = view.data.parentForm;
          let basicWrapper = document.querySelector(`#${view.css_id}`); // .basic`);

          /**
           * @type FormExportXmlBuilder
           */
          let builder = new FormExportXmlBuilder();
          view.data.configBuilder = builder;

          builder.loadFormSchema(form.schema);

          if (row && row.data && row.data.config) builder.load(row.data.config);
          basicWrapper.appendChild(builder.node);
          return builder;
        },
        access: (row) => !!row.id,
      },
      form: {
        type: "model",
        hideInTable: true,
        getString: (row) => schema.form.schemaData.name.getString(row.form),
      },
      formPartner: {
        type: "collection",
        populate: true,
        hideInTable: true,
        getString: (row) =>
          row.formPartner.map((fp) => fp.partner.name).join(", "),
      },
    },
  };

  this.formImage = {
    endPoint: API_PATH + "formImage",
    schemaData: {
      form: {
        type: "model",
      },
    },
  };

  this.formPartner = {
    endPoint: API_PATH + "formPartner",
    schemaData: {
      useable: {
        type: "checkbox",
        defaultsTo: true,
      },
      form: {
        type: "model",
        required: true,
        getString: (row) => schema.form.schemaData.name.getString(row.form),
      },
      partner: {
        type: "model",
        required: true,
        getString: (row) => row.partner.name,
      },
      customer: {
        type: "collection",
      },
    },
  };

  this.customer = {
    endPoint: API_PATH + "customer",
    schemaData: {
      date: {
        type: "datetime",
        required: true,
      },
      // set to true when the cronJob sends an email to customer
      customer_notified: {
        type: "checkbox",
        defaultsTo: false,
      },
      data: {
        type: "text",
        required: true,
        access: false,
      },
      locationPartner: {
        type: "model",
        populate: true,
        getString: (row) => row.locationPartner.location.name,
      },
      formPartner: {
        type: "model",
        populate: true,
        getString: (row) => row.formPartner.form.name,
      },
      employeePartner: {
        type: "model",
        populate: true,
        getString: (row) => row.employeePartner.partner.name,
      },
    },
    accessCreate: () => false,
  };

  this.appLicence = {
    endPoint: API_PATH + "appLicence",
    schemaData: {
      key: {
        type: "text",
        unique: true, //not handled in client yet
        access: () => false, //readonly
      },
      device_name: {
        type: "text",
      },
      last_activity: {
        type: "datetime",
        defaultsTo: null,
        access: () => false,
      },
      partnerGroup: {
        type: "model",
        required: true,
        access: (row) => !row.id,
        getString: (row) => row.partnerGroup.name,
      },
      //is a function on server. Set this to true to rest the device_token
      isFree: {
        type: "checkbox",
        access: (row) => row.id && !row.isFree,
        getString: (row) => row.isFree,
      },
    },
  };

  this.automaticExport = {
    endPoint: API_PATH + "automaticExport",
    schemaData: {
      name: {
        type: "text",
        required: true,
        access: () => true,
      },
      active: {
        hideInTable: true,
        type: "checkbox",
        defaultsTo: true,
        access: (row) => accessUserEdit(row) && !row.active,
      },
      filename: {
        hideInTable: true,
        type: "text",
        access: () => false,
        hideInDetails: true,
      },
      zipPassword: {
        hideInTable: true,
        type: "text",
        access: () => false,
        hideInDetails: true,
      },
      exportAsExcel: {
        hideInTable: true,
        type: "checkbox",
        access: () => false,
        hideInDetails: true,
      },
      singleUpload: {
        hideInTable: true,
        type: "checkbox",
        access: () => false,
        hideInDetails: true,
      },
      csvConfig: {
        hideInDetails: true,
        type: "model",
        sortable: false,
        access: () => false,
        getString: (row) => {
          if (row.csvConfig) {
            return row.csvConfig.name;
          }
        },
      },
      pdfConfig: {
        hideInDetails: true,
        type: "model",
        sortable: false,
        access: () => false,
        getString: (row) => {
          if (row.pdfConfig) {
            return row.pdfConfig.name;
          }
        },
      },
      xmlConfig: {
        hideInDetails: true,
        type: "model",
        access: () => false,
        sortable: false,
        getString: (row) => {
          if (row.xmlConfig) {
            return row.xmlConfig.name;
          }
        },
      },
      ftpConfig: {
        hideInDetails: true,
        type: "model",
        access: () => false,
        hideInTable: true,
        sortable: false,
        getString: (row) => {
          if (row.ftpConfig) {
            return row.ftpConfig.hostname;
          }
        },
      },
      smtpConfig: {
        hideInDetails: true,
        type: "model",
        access: () => false,
        hideInTable: true,
        sortable: false,
        getString: (row) => {
          if (row.smtpConfig) {
            return row.smtpConfig.emails;
          }
        },
      },
      dateConfig: {
        type: "model",
        access: () => false,
        hideInTable: false,
        sortable: false,
        getString: (row) => {
          if (row.dateConfig.interval) {
            return lng.get(row.dateConfig.interval);
          } else {
            return "";
          }
        },
      },
      exportConfig: {
        type: "model",
        access: () => false,
        getString: (row) => {
          if (row.exportConfig) {
            const formName = row.exportConfig.form
              ? row.exportConfig.form.name
              : "";
            return `${formName}`;
          } else {
            return "";
          }
        },
        sortable: false,
        hideInDetails: true,
      },
      partner: {
        type: "model",
        required: true,
        getString: (row) => {
          return row.partner.name;
        },
        hideInDetails: false,
        sortable: true,
      },
      schema: {
        type: "json",
        required: true,
        hideInTable: true,
        customEdit: (row) => {
          const automaticExport = new AutomaticExport();
          automaticExport.loadJson(row);
          document
            .getElementById(CONTENT_TARGET.currentContent.css_id)
            .appendChild(automaticExport.node);
          return automaticExport;
        },
        access: (row) => row.id,
      },
    },
  };

  this.affiliates = {
    endPoint: API_PATH + "affiliates",
    schemaData: {
      partner: {
        type: "model",
        required: true,
        getString: (row) => row.partner.name,
      },
      form: {
        type: "model",
        required: true,
        getString: (row) => {
          return schema.form.schemaData.name.getString(row.form);
        },
      },
    },
  };

  // init
  const that = this;
  (function () {
    // auto full fill some stuff
    for (let schemaKey in that) {
      let schema = that[schemaKey];

      //main label in plural
      schema.label = lng.get(schemaKey + "s");

      for (let key in schema.schemaData) {
        let schemaItem = schema.schemaData[key];

        switch (schemaItem.type) {
          case "model":
            var lngKey = key || schemaItem.via;
            var modelKey = schemaItem.via || key;

            // -- label --
            //first check for `${parent}_${child}`
            var parentChildLngKey =
              schemaKey + "_" + snakeCaseToCamelCase(lngKey);
            schemaItem.label = lng.get(parentChildLngKey);

            //if not defined use `${child}`
            if (!schemaItem.label) schemaItem.label = lng.get(modelKey);

            if (!schemaItem.label)
              console.warn(
                `Missing lng item for ${parentChildLngKey}. Also missing the fallback ${modelKey}`
              );

            break;
          case "collection":
            var lngKey = key || schemaItem.via;
            let collectionKey = schemaItem.via || key;

            // -- label --
            //like for model
            var parentChildLngKey =
              schemaKey + "_" + snakeCaseToCamelCase(lngKey);
            schemaItem.label = lng.get(parentChildLngKey);

            if (!schemaItem.label)
              schemaItem.label = lng.get(collectionKey + "s"); //s for plural

            if (!schemaItem.label)
              console.warn(
                `Missing lng item for ${parentChildLngKey}. Also missing the fallback ${collectionKey}`
              );

            //columns of a collection
            for (
              let i = 0, len = (schemaItem.cols || []).length;
              i < len;
              i++
            ) {
              let col = schemaItem.cols[i];

              //could not identify the target without a key
              if (!col.key) continue;

              // -- label for col of collection --
              var colLngKey =
                collectionKey + "_" + snakeCaseToCamelCase(col.key);
              col.label = lng.get(colLngKey);
              if (!col.label)
                console.warn(
                  `Missing lng item for ${colLngKey} (${schemaKey}.${collectionKey}.${col.key})`
                );

              // -- function for col of collection --
              //if no function defined try to apply getString function from main schema
              if (!col.function) {
                //check existence of schemas
                let mainSchema = that[collectionKey];
                if (!mainSchema) {
                  console.error(
                    `Schema ${collectionKey} missing (${schemaKey}.${collectionKey}.${col.key})`
                  );
                  continue;
                }

                let mainSchemaItem = mainSchema.schemaData[col.key];
                if (!mainSchemaItem) {
                  console.error(
                    `${col.key} in Schema ${collectionKey} missing (${schemaKey}.${collectionKey}.${col.key})`
                  );
                  continue;
                }

                if (col.edit) {
                  //edit the value of collection item

                  switch (mainSchemaItem.type) {
                    case "model":
                    case "collection":
                      console.error(
                        `col.edit not suported for model or collections. (${schemaKey}.${collectionKey}.${col.key})`
                      );
                      continue;
                  }

                  col.function = function (subject, row) {
                    //generate input with global specifications. The div is only cause the parameter is reuired
                    var input = RestEdit.genInput(
                      mainSchemaItem,
                      collectionKey,
                      document.createElement("div")
                    );
                    input.instance;

                    if (mainSchemaItem.access && !mainSchemaItem.access(row))
                      input.disabled = true;

                    //get value from row
                    var val = row[col.key];
                    switch (input.type) {
                      case "checkbox":
                        input.checked = !!val;
                        break;
                      case "date":
                        input.value = val ? val.split("T")[0] : null;
                        break;
                      default:
                        input.value = val || null;
                    }

                    var eventType;
                    switch (mainSchemaItem.type) {
                      case "checkbox":
                        eventType = "click";
                        break;
                      case "date":
                      case "select":
                        eventType = "change";
                        break;
                      default:
                        eventType = "keyup";
                    }

                    input.addEventListener(eventType, function (e) {
                      if (eventType === "keyup" && e.keyCode !== 13) return;

                      input.disabled = true;

                      if (!input.instance) {
                        input.instance = restCollection[collectionKey].findOne(
                          row.id
                        );
                      }

                      input.instance.then((instance) => {
                        instance.data[col.key] =
                          input.type === "checkbox"
                            ? input.checked
                            : input.value;
                        instance
                          .save()
                          .then(() => subject.reload())
                          .then(() => {
                            input.disabled = false;

                            //do not confound with native onchange
                            if (typeof input.onChange === "function")
                              input.onChange();
                          });
                      });
                    });

                    return input;
                  };
                } else {
                  let functionFromMainSchema = mainSchemaItem.getString;
                  if (functionFromMainSchema) {
                    //getString function from main schema
                    col.function = (subject, row) =>
                      functionFromMainSchema(row);
                  } else {
                    //default: simply return the value of the column
                    col.function = (subject, row) => {
                      let val = row[col.key];

                      //parse date
                      if (mainSchemaItem.type === "date" && val)
                        return new Date(val).toLocaleDateString();

                      //parse datetime
                      if (mainSchemaItem.type === "datetime" && val)
                        return new Date(val).toLocaleString();

                      //parse true, false, undefined
                      switch (val) {
                        case true:
                          return schema.ICONS.DONE;
                        case null:
                        case false:
                        case undefined:
                          return "";
                        default:
                          return val + "";
                      }
                    };
                  }
                }
              }
            }
            break;
          case "static":
            var lngKey = key || schemaItem.via;
            var modelKey = schemaItem.via || key;
            schemaItem.label = lng.get(modelKey);
            break;
          default:
            // -- label --
            schemaItem.label = lng.get(
              schemaKey + "_" + snakeCaseToCamelCase(key)
            );
        }
      }
    }
  })();
}
